import React, { useMemo } from 'react';
import ContextMenu from './context-menu';
import { COLORS, ICONS } from '../general-components/icon';
import { MenuItem } from '../general-components/right-click-menu';
import Socket from '../../connection/socket';
import { Shot } from '../../stores/reducers/shots';
import {
	useDuplicateShot,
	useOpenDeleteModal,
	useOpenShotModal,
	useToggleAutoplay,
} from '../../hooks/use-shot-utilities';
import { CssPosition } from '../../stores/types/types';

interface ShotContextMenuProps {
	menuPosition: CssPosition;
	isShowing: boolean;
	onMenuBlur: () => void;
	clickInitiator: React.MutableRefObject<HTMLElement | null>;
	isAutoplaying: boolean;
	autoplayHidden: boolean;
	editHidden: boolean;
	socket?: Socket | null;
	shot: Shot;
}

export default function ShotContextMenu({
	menuPosition,
	isShowing,
	onMenuBlur,
	clickInitiator,
	editHidden,
	isAutoplaying,
	autoplayHidden,
	socket,
	shot,
}: ShotContextMenuProps) {
	const handleOpenShotModal = useOpenShotModal();
	const handleDuplicateShot = useDuplicateShot();
	const handleToggleAutoplay = useToggleAutoplay();
	const handleOpenDeleteModal = useOpenDeleteModal();

	const menuItems: MenuItem[] = useMemo(() => [
		{
			hidden: editHidden,
			handleClick: () => handleOpenShotModal(shot, socket),
			iconName: ICONS.EDIT,
			text: 'Edit',
		},
		{
			hidden: false,
			handleClick: () => handleDuplicateShot(shot, socket),
			iconName: ICONS.MEDIA_DUPLICATE,
			text: 'Duplicate',
		},
		{
			hidden: true,
			handleClick: () => {},
			iconName: ICONS.VIEWERS_EYE,
			text: 'Hide',
		},
		{
			hidden: autoplayHidden,
			handleClick: () => handleToggleAutoplay(shot),
			checkboxValue: isAutoplaying,
			text: 'Autoplay',
		},
		{
			hidden: false,
			handleClick: () => handleOpenDeleteModal(shot, socket),
			iconName: ICONS.TRASH,
			text: 'Delete',
			color: COLORS.RED,
		},
	], [
		handleOpenShotModal,
		handleDuplicateShot,
		handleToggleAutoplay,
		handleOpenDeleteModal,
		isAutoplaying,
	]);

	return (
		<ContextMenu
			menuPosition={menuPosition}
			{...{
				menuItems,
				isShowing,
				clickInitiator,
				onMenuBlur,
			}}
		/>
	);
}
